import Http from '@/services/httpAcademy'

export const listProducts = (params) =>
	Http.get('/admin/products', { params })

export const approveProduct = ({ id }) =>
	Http.patch(`/admin/products/${id}/approve`)

export const rejectProduct = ({ id, reason }) =>
	Http.patch(`/admin/products/${id}/reject`, { reason })

export const featureProduct = ({ id }) =>
	Http.patch(`/admin/products/${id}/feature`)
